<template>
    <div class="nav">
        <a v-for="(nav,index) in navList" :key="index" :href="nav.link">
            <p>
                <img :src="nav.icon" alt="">
            </p>
            <p>{{nav.name}}</p>     
        </a>   
    </div>
</template>

<script>
import icon1 from '../../../assets/images/xb_icon01.png'
import icon2 from '../../../assets/images/xb_icon02.png'
import icon3 from '../../../assets/images/xb_icon03.png'
import icon4 from '../../../assets/images/xb_icon04.png'

export default{
    name: 'Nav',
    data(){
        return{
            navList:[
                {link: `#/childteachlist/${encodeURI('图形化编程')}/51034`, name: '图形化编程', icon: icon1},
                {link: `#/childteachlist/${encodeURI('C语言')}/51033`, name: 'C语言', icon: icon2},
                {link: `#/childteachlist/${encodeURI('Pyhton')}/51042`, name: 'Pyhton', icon: icon3},
                {link: `#/childteachlist/${encodeURI('少儿编程英语')}/51041`, name: '少儿编程英语', icon: icon4},
            ]    
        }
    },
    created(){
        
    },
    methods:{
        
    },
    components: {

    }
}
</script>

<style lang="less" scoped>
    .nav{
        padding-top: 0.3rem;
        margin-bottom: 0.3rem;
        background: #fff;
        overflow: hidden;
        border-bottom: 0.2rem solid #f3f3f3;
        a{
            display: block;
            float: left;
            width: 25%;
            text-align: center;
            color: #333;
            font-size: 0.38rem;
            margin-bottom: 0.3rem;
        }
        p{
            &:nth-of-type(1){
                margin-bottom: 0.1rem;
            }
        }
        img{
            width: 42%;
        }
    }          
</style>   